import React, { useEffect } from 'react';
import { PricingConfigurator } from '../components/PricingConfigurator';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';
import { RevealWrapper } from '../hooks/useReveal';
import { Shield, Cloud, Zap, Sparkles, Rocket } from 'lucide-react';

export const PreisePage = () => {
  const navigate = useNavigate();

  // SEO: Update document title and meta description
  useEffect(() => {
    document.title = 'Nextcloud Hosting Preise | Ab 9€/Monat | Wolkenhelden';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transparente Preise für Managed Nextcloud Hosting. Ab 9€/Monat inkl. 250GB S3-Speicher, SSL, Backups. Konfigurator für individuelle Pakete. Keine versteckten Kosten!');
    }
  }, []);

  return (
    <div className="py-16 md:py-24" data-testid="preise-page">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <RevealWrapper>
          <div className="mb-12 text-center">
            <h1 className="font-display text-4xl font-semibold tracking-tight sm:text-5xl">
              Managed Nextcloud Hosting Preise 🦸
            </h1>
            <p className="mt-4 text-lg text-muted-foreground md:text-xl">
              Stell dir deine Cloud zusammen, wie du sie brauchst.
              <br />
              Du siehst den Preis live – ohne Kleingedrucktes oder versteckte Kosten.
            </p>
          </div>
        </RevealWrapper>

        {/* Trust Strip */}
        <RevealWrapper delay={100}>
          <Card className="glass-card mb-12 border-primary/20 bg-gradient-to-r from-primary/5 to-blue-500/5">
            <CardContent className="py-6">
              <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
                <div className="flex items-center gap-2">
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
                    <Shield className="h-4 w-4 text-primary" />
                  </div>
                  <span className="font-medium">🛡️ Helden-Verfügbarkeit im HA-Cluster</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
                    <Cloud className="h-4 w-4 text-primary" />
                  </div>
                  <span className="font-medium">☁️ Helden-Speicher (S3)</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
                    <Zap className="h-4 w-4 text-primary" />
                  </div>
                  <span className="font-medium">⚡ Blitzschnell & selbstheilend</span>
                </div>
              </div>
              <p className="mt-4 text-center text-xs text-muted-foreground">
                🦸 Deine Helden-Cloud läuft auf unserer hochverfügbaren Plattform – bei ALLEN Tarifen inklusive!
              </p>
            </CardContent>
          </Card>
        </RevealWrapper>

        {/* Configurator */}
        <RevealWrapper delay={200}>
          <div className="mb-8 text-center">
            <h2 className="font-display text-3xl font-semibold mb-2 flex items-center justify-center gap-2">
              <Sparkles className="h-6 w-6 text-primary" />
              Wähle deine Superkräfte
            </h2>
            <p className="text-muted-foreground">
              Maximale Flexibilität – buche genau das, was du brauchst. Du kannst später jederzeit upgraden! 🚀
            </p>
          </div>
        </RevealWrapper>

        <RevealWrapper delay={300}>
          <PricingConfigurator />
        </RevealWrapper>

        {/* CTA */}
        <RevealWrapper delay={400}>
          <div className="mt-12 text-center">
            <Button
              size="lg"
              onClick={() => navigate('/checkout')}
              className="bg-gradient-to-r from-primary to-blue-600 hover:from-primary/90 hover:to-blue-600/90 transition-all hover:scale-105 shadow-lg shadow-primary/25 text-lg px-8"
              data-testid="weiter-zur-bestellung-button"
            >
              <Rocket className="mr-2 h-5 w-5" />
              Jetzt Held werden!
            </Button>
            <p className="mt-4 text-sm text-muted-foreground">
              ✨ Monatlich kündbar – ohne Drama, ohne Stress, ohne Kleingedrucktes.
            </p>
          </div>
        </RevealWrapper>
      </div>
    </div>
  );
};
